import ProService from "@/services/pro-service";
import { handleError } from "@/utils/error";
import type { CalendarAvailability } from "@/utils/parse-calendar-availability";
import { parseCalendarAvailability } from "@/utils/parse-calendar-availability";
import { defineStore } from "pinia";
import type { User } from "@/types/user";

const proService = new ProService("pros");

export const useProAvailabilityStore = defineStore("pro-availability", {
  state: () => ({
    availability: {} as CalendarAvailability,
  }),
  actions: {
    clearAll() {
      this.availability = {
        availableDates: { start: new Date(), end: new Date() },
        disabledDates: [],
        availableHoursPerDay: {},
      };
      localStorage.removeItem("availability");
    },
    async getProCalendarAvailability(pro: User, timezone?: string) {
      try {
        const availability = await proService.getProCalendarAvailability(
          pro._id,
        );

        this.availability = parseCalendarAvailability(
          availability.availableDates,
          availability.intervals,
          timezone ?? pro.timezone,
        );
      } catch (error) {
        throw handleError(error);
      }
    },
    setAvailability(data: CalendarAvailability) {
      this.availability = data;
    },
  },
  persist: {
    storage: persistedState.localStorage,
  },
});
